import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

export const takePicture = async () => {
  try {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri,
      source: CameraSource.Camera
    });

    // Convert the URI to a Blob
    const response = await fetch(image.webPath);
    const blob = await response.blob();
    
    // Create a File object from the Blob
    const file = new File([blob], 'camera-image.jpg', { type: 'image/jpeg' });
    
    return {
      file,
      preview: image.webPath
    };
  } catch (error) {
    console.error('Error taking picture:', error);
    throw error;
  }
};

export const pickFromGallery = async () => {
  try {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri,
      source: CameraSource.Photos
    });

    // Convert the URI to a Blob
    const response = await fetch(image.webPath);
    const blob = await response.blob();
    
    // Create a File object from the Blob
    const file = new File([blob], 'gallery-image.jpg', { type: 'image/jpeg' });
    
    return {
      file,
      preview: image.webPath
    };
  } catch (error) {
    console.error('Error picking from gallery:', error);
    throw error;
  }
}; 